import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './MenuTitleLoyalty.css';

class MenuTitleLoyalty extends Component {
  render() {
    const {
      menuTitle,
      loyaltySubscription: { subscriptionDetail },
      showUpgradeToProButton,
    } = this.props;
    const detailBasic = subscriptionDetail.Loyalty;
    const detailPro = subscriptionDetail['Loyalty Pro'];

    return (
      <div className={`hidden-xs hidden-sm col-md-8 ${styles['menu-title']}`}>
        <div>
          <h2 className={styles['menu-title-loyalty']}>{menuTitle}</h2>
        </div>
        {detailPro && detailPro.is_active && (
          <div className={styles['menu-title-text']}>
            <span className={styles['menu-title-crm']}>CRM</span>{' '}
            <span className={styles['menu-title-pro']}>Pro</span>
          </div>
        )}
        {detailPro &&
          !detailPro.is_active &&
          detailBasic &&
          detailBasic.is_active && (
            <div className={styles['menu-title-text']}>
              <span className={styles['menu-title-crm']}>CRM</span>{' '}
              <span className={styles['menu-title-basic']}>Basic</span>
            </div>
          )}
        {detailPro &&
          !detailPro.is_active &&
          detailBasic &&
          detailBasic.is_active &&
          showUpgradeToProButton && (
            <div>
              <button
                className={`${styles['button-upgrade-pro']}`}
                onClick={this._onClickUpgradeToPro}
              >
                Upgrade to Pro!
              </button>
            </div>
          )}
      </div>
    );
  }

  _onClickUpgradeToPro = e => {
    e.stopPropagation();
    this.props.goToSubscribeView();
  };
}

MenuTitleLoyalty.defaultProps = {
  showUpgradeToProButton: true,
};

function mapStateToProps(state) {
  const { loyaltySubscription } = state.customers;

  return {
    loyaltySubscription,
  };
}

export default connect(mapStateToProps)(MenuTitleLoyalty);
